import React from 'react'

const ClockbeatsOrchestra = () =>
  <div>
    <section className="container full">
      <div className="col-12-of-12">
        <img src={require('img/clockbeats-orchestra/bg_main.jpg')} alt="Blip Feature" />
      </div>
    </section>
    <section className="container">
      <div className="client-quote">
        <blockquote>
        We are, however, not talking about the classic orchestra everyone has in mind but something more. <br/>
        It’s a modern concept because, starting from a classical background, we envisage
        a mix, up to now unexplored, of interaction with sounds and di erent technologies: 
        it will be possible to change the sound of the live orchestra and attain other kinds of timbres. <br/>
        There will be also a visual concept where the music will come alive through images so that the audience will experience a way more satisfying concert.        
        </blockquote>
      </div>
    </section>
    <section className="container">
      <div className="col-12-of-12">
      <iframe src="https://player.vimeo.com/video/187040577" width="100%" height="720" frameBorder="0" allowFullScreen></iframe>
      <p><a href="https://vimeo.com/187040577">Clockbeats Orchestra - This is our Time</a> from <a href="https://vimeo.com/user46244838">Clockbeats</a> on <a href="https://vimeo.com">Vimeo</a>.</p>
      </div>
    </section>
    <section className="container full split-view m-tb-m">
      <aside className="content">
        <h3>How it works</h3>
        <h4 style={{ marginBottom: "20px"}}>
        By checking our website you’ll discover all the artists involved in the project,
        divided into the di erent categories of their instruments. In this way you can get to know every musician easily. <br/>
        A er checking the artist, you can decide to “adopt” a musician by donating.        
        </h4>
        <a href="https://clockbeatsorchestra.com/" target="_blank" rel="noopener noreferrer" className="btn dark">View website</a>
      </aside>
      <aside>
      <img src={require('img/clockbeats-orchestra/piano_cello.jpg')} alt="Clockbeats Orchestra piano and cello" />
      </aside>
    </section>

    <section className="container full split-view m-tb-m">
      <aside>
        <img src={require('img/clockbeats-orchestra/orchestra_map.png')} alt="Clockbeats orchestra map" />
      </aside>
      <aside className="content">
        <h3>Our Mission</h3>
        <h4>
        Our goal is to arrange a series of concerts starting in North Italy, 
        spreading throughout Europe and the the World in the cities where the project already has its roots: 
        Berlin, New York, Anversa, Copenhaghen, London, The Hague.
        </h4>
      </aside>
      
    </section>

    <section className="container">
      <div className="client-quote">
        <blockquote className="text-center">
          No schemes, prejudices, genres, classifications, labels… Just Music!
        </blockquote>
      </div>
    </section>
    <section className="container">
      <div className="col-12-of-12">
        <img src={require('img/clockbeats-orchestra/orchestra_dark.jpg')} alt="Clockbeats orchestra live performance" />
      </div>
    </section>
  </div>

export default ClockbeatsOrchestra



// WEBPACK FOOTER //
// src/javascripts/clients/ClockbeatsOrchestra.js